import { Avatar } from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import TableLoader from "@/Components/common/TableLoader";
import TableNoContent from "@/Components/common/TableNoContent";
import { routingConstants } from "@/Constants/routingConstants";
import {
  fetchWorkedCandidates,
  setWorkedCandidatesLoading,
  updateSelectedCandidate,
  updateSelectedContract,
  updateToggleSelected,
  updatePagination,
  updateListView,
  fetchWorkedShifts,
  toggleSelectedAll,
  deSelectAllCandidate,
  updateSorting,
} from "@/reducers/client_candidates/candidatesworked";
import { setLoading } from "@/reducers/clientcontractdetail";
import { fetchCandidateTypes } from "@/reducers/clientdashboard";
import {
  expandButtonColumn,
  getActionByHtml,
  getColumnNormalHtml,
  totalDaysColumn,
} from "@/utilities/datatable/columnFunctions";
import useDebounceScroll from "@/utilities/hooks/useDebounceScroll";
import { getComplianceClass } from "@/utilities/utils";

import { Miles } from "./common/Miles";
import { SelectedCountText } from "./common/SelectedCountText";
import SwitchListView from "./common/SwitchListView";
import WorkedShifts from "./common/WorkedShifts";
import { Actions } from "./Worked/Actions";
import { FilterModal } from "./Worked/FilterModal";
import { SearchFilter } from "./Worked/SearchFilter";
import WorkedStatusButton from "./Worked/WorkedStatusButton";
import CoverIcon from "../../../../Icons/CoverIcon";
import DataTablePaginationLoader from "../../../../Skeletons/DataTablePaginationLoader";
import CandidateStatusAndInfo from "../../dataTables/CandidateStatusAndInfo";
import ClientPayPopover from "../../dataTables/ClientPayPopover";
import BlurredText from "../../managedService/BlurredText";
/**
 * Renders a list of candidates previously worked, with various details and actions.
 *
 * @returns {JSX.Element} The rendered list of candidates previously worked.
 */
export const WorkedList = () => {
  const dispatch = useDispatch();
  const {
    workedCandidates,
    selectedCandidate,
    isLoading,
    selectedSignOffIds,
    filters,
    sorting,
    toggleSelected,
    listView,
    pagination,
    totalCount,
    isSelectedAll,
    isPaginationLoading,
  } = useSelector((state) => state.clientCandidatesWorked);
  const [data, setData] = useState([]);
  const { clientUserAllPermissions } = useSelector((state) => state.session);

  const [diffList, setDiffList] = useState([]); // list of candidate which required edit on approve click

  useEffect(() => {
    setData(workedCandidates);
  }, [workedCandidates]);
  useEffect(() => {
    if (selectedCandidate.length == 0) {
      dispatch(updateToggleSelected());
    }
  }, [selectedCandidate]);
  useEffect(() => {
    if (diffList.length > 0) {
      setTimeout(() => {
        setDiffList([]);
      }, 10000);
    }
  }, [diffList]);
  const columns = [
    {
      name: "Candidate",
      sortable: true,
      sortField: "candidate_forename",
      // sortFunction: (rowA, rowB) => sortByText(rowA, rowB, "candidate_name"),
      selector: (row) => (
        <div className="flex gap-[14px]" data-tag="allowRowEvents">
          <div className="min-w-[45px]">
            <Avatar
              alt={row.candidate_name}
              sx={{ width: 45, height: 45 }}
              src={row.profile_image ? row.profile_image : ""}
            />
          </div>
          <div className="flex grow flex-col gap-1 overflow-hidden">
            {(!clientUserAllPermissions ||
              clientUserAllPermissions.is_allow_to_view_candidate_profile ===
                1) &&
            row.is_past_booking ? (
              <>
                <Link
                  to={routingConstants.candidateDetail(row.route_id)}
                  className="truncate text-[14px] font-semibold leading-[normal] text-black"
                >
                  {row.candidate_name}
                </Link>
              </>
            ) : (
              <span className="cursor-not-allowed truncate text-[14px] font-semibold leading-[normal] text-black">
                {row.candidate_name}
              </span>
            )}
            <CandidateStatusAndInfo
              sortlisted={row.candidate_sortlisted}
              unsuitable={row.candidate_unsuitable}
              is_auto_booked_on_apply={row.is_auto_booked_on_apply}
              extraEle={
                !clientUserAllPermissions ||
                clientUserAllPermissions.is_allow_to_view_contract_detail ===
                  1 ? (
                  <div className="flex flex-wrap items-center gap-1">
                    <Link
                      to={routingConstants.contractDetail(
                        row.route_contract_id,
                      )}
                      className="line-clamp-1 text-[12px] font-medium leading-[normal] text-txtColor"
                    >
                      {row.contract_ref_no}
                    </Link>
                    {row?.is_substitute_contract && listView !== "shifts" ? (
                      <div
                        div
                        className={`flex h-[25px] w-[37px] cursor-pointer items-center gap-2 rounded-[4px] bg-lightOrange px-2 py-1 text-center font-medium leading-[23px] text-darkOrange`}
                      >
                        <CoverIcon cls="text-darkOrange" />
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div className="flex flex-wrap gap-2">
                    <span className="line-clamp-1 cursor-default text-[12px] font-medium leading-[normal] text-txtColor">
                      {row.contract_ref_no}
                    </span>
                    {row?.is_substitute_contract && listView !== "shifts" ? (
                      <div
                        div
                        className={`flex h-[25px] w-[37px] cursor-pointer items-center gap-2 rounded-[4px] bg-lightOrange px-2 py-1 text-center font-medium leading-[23px] text-darkOrange`}
                      >
                        <CoverIcon cls="text-darkOrange" />
                        <span className={`text-[12px] text-darkOrange`}>
                          {"Cover"}
                        </span>
                      </div>
                    ) : null}
                  </div>
                )
              }
            />

            {/* <CandidateStatusAndInfo
               sortlisted={row.candidate_sortlisted}
               unsuitable={row.candidate_unsuitable}
               extraEle={<Link
                 to={routingConstants.contractDetail(row.route_contract_id)}
                 className="line-clamp-1 text-[12px] font-medium leading-[normal]  text-txtColor"
               >
                 {row.contract_ref_no}
               </Link>}
             /> */}
          </div>
        </div>
      ),
      width: listView === "shifts" ? "205px" : "20%",
    },
    {
      name: "Contact",
      sortable: true,
      // sortFunction: (rowA, rowB) => sortByText(rowA, rowB, "candidate_email"),
      sortField: "candidate_email",
      selector: (row) => (
        <div className="flex flex-col" data-tag="allowRowEvents">
          <BlurredText type="phone" blurKey={!row.is_past_booking}>
            <span className="truncate text-[14px] font-semibold leading-[normal] text-black">
              {row.mobile_phone_number || "+447676764646"}
            </span>
          </BlurredText>
          <BlurredText type="email" blurKey={!row.is_past_booking}>
            <span className="truncate text-[12px] font-medium leading-[normal] text-txtColor">
              {row.candidate_email || "shahkhalid@yopmail.com"}
            </span>
          </BlurredText>
        </div>
      ),
      width: listView === "shifts" ? "165px" : "15%",
    },
    {
      name: "Miles",
      // sortable: true,
      // sortFunction: (rowA, rowB) => sortByNumber(rowA, rowB, "miles"),
      // sortField: 'miles',
      selector: (row) => <Miles miles={row.miles} />,
      width: "8%",
    },
    {
      name: "Role",
      sortable: true,
      sortField: "role_name",

      // sortFunction: (rowA, rowB) => sortByText(rowA, rowB, "role_name"),
      selector: (row) => (
        <div className="flex flex-col" data-tag="allowRowEvents">
          {getColumnNormalHtml(
            row.role_name || "-",
            "line-clamp-2 whitespace-break-spaces",
          )}
          <span className="text-[12px] font-medium leading-[normal] text-txtColor">
            {row.license_number}
          </span>
        </div>
      ),
      width: listView === "shifts" ? "8%" : "11%",
    },
    ...(listView === "shifts"
      ? [
          {
            name: "Actioned By",
            // sortable: true,
            // sortFunction: (rowA, rowB) => sortByText(rowA, rowB, "actioned_by"),
            selector: (row) => (
              <div className="flex flex-col" data-tag="allowRowEvents">
                {getActionByHtml(
                  row.timesheet_status === "Authorised"
                    ? row?.authorised_by_name
                    : row?.timesheet_status == "Rejected"
                      ? row.rejected_by_name
                      : row.timesheet_status == "Terminated"
                        ? row.terminated_by_name
                        : "-",
                  row.timesheet_status === "Authorised"
                    ? row?.authorised_at
                    : row?.timesheet_status == "Rejected"
                      ? row.rejected_at
                      : row?.timesheet_status == "Terminated"
                        ? row.terminated_at
                        : "-",
                  row.timesheet_status === "Authorised"
                    ? row?.authorised_from
                    : row?.timesheet_status == "Rejected"
                      ? row.rejected_from
                      : row?.timesheet_status == "Terminated"
                        ? row.terminated_from
                        : "-",
                  "",
                )}
              </div>
            ),
            width: "12%",
          },
        ]
      : []),

    {
      name: "Shift Date",
      sortable: true,
      sortField:
        listView === "shifts" ? "contract_date" : "contract_start_date",

      // sortFunction: (rowA, rowB) => {
      //   if (listView === "shifts") {
      //     // Sort by shift_date if listView is "shifts"
      //     return sortByDate(
      //       moment(rowA.shift_date).format("DD/MM/YYYY"),
      //       moment(rowB.shift_date).format("DD/MM/YYYY")
      //     );
      //   } else {
      //     // Sort by contract_start_date if listView is not "shifts"
      //     return sortByDate(
      //       moment(rowA.contract_start_date).format("DD/MM/YYYY"),
      //       moment(rowB.contract_end_date).format("DD/MM/YYYY")
      //     );
      //   }
      // },
      selector: (row) => (
        <div
          className="flex flex-col items-end gap-1"
          data-tag="allowRowEvents"
        >
          {listView === "shifts" ? (
            <>
              <span className="text-[14px] font-semibold leading-[normal] text-black">
                {moment(row.shift_date).format("DD/MM/YYYY")}
              </span>
              <span
                className={`h-[23px] w-[75px] rounded-[4px] text-center text-[14px] font-medium leading-[23px] ${getComplianceClass(
                  row.profile_percent,
                )}`}
              >
                {row.profile_percent == "-" ? "0%" : row.profile_percent + "%"}
              </span>
            </>
          ) : (
            <>
              <span className="text-[14px] font-semibold leading-[normal] text-black">
                {moment(row.contract_start_date).format("DD/MM/YYYY")}
              </span>
              <span className="text-[14px] font-semibold leading-[3px] text-black">
                -
              </span>
              <span className="text-[14px] font-semibold leading-[normal] text-black">
                {moment(row.contract_end_date).format("DD/MM/YYYY")}
              </span>
            </>
          )}
        </div>
      ),
      width: listView === "shifts" ? "7.5%" : "",
    },
    ...(listView !== "shifts"
      ? [
          {
            name: "Total Days",

            selector: (row) => (
              <div className="flex flex-col items-center">
                <p className="text-[14px] font-semibold leading-[normal] text-black">
                  {row.days_total ? row.days_total : "0"}
                </p>
                <span
                  className={`mt-[2px] h-[23px] w-[75px] rounded-[4px] text-center text-[14px] font-medium leading-[23px] ${getComplianceClass(
                    row.profile_percent,
                  )}`}
                >
                  {row.profile_percent == "-"
                    ? "0%"
                    : row.profile_percent + "%"}
                </span>
              </div>
            ),
            width: "",
          },
          totalDaysColumn("Worked", "days_worked", ""),
          totalDaysColumn(
            "Booked",
            "days_booked",
            "",
            false,
            routingConstants.bookedCandidate,
          ),
          expandButtonColumn(),
        ]
      : [
          {
            name: "Shift",
            sortable: true,
            sortField: "contract_start_time",
            selector: (row) => (
              <div className="flex flex-col items-end gap-1">
                {getColumnNormalHtml(
                  moment(row.contract_start_time, "HH:mm:ss").format("HH:mm"),
                )}
                <span className="text-[14px] font-semibold leading-[0px] text-black">
                  -
                </span>
                {getColumnNormalHtml(
                  moment(row.contract_end_time, "HH:mm:ss").format("HH:mm"),
                )}
              </div>
            ),
            width: "65px",
          },
          {
            name: "Break/Admin",
            sortable: true,
            sortField: "un_paid_break_hour",
            selector: (row) => (
              <div className="flex flex-col items-end gap-1">
                {getColumnNormalHtml(
                  moment(row.break_time, "HH:mm:ss").format("HH:mm"),
                )}
                <span className="text-[14px] font-semibold leading-[0px] text-black">
                  -
                </span>
                {getColumnNormalHtml(
                  moment(row.admin_time, "HH:mm:ss").format("HH:mm"),
                )}
              </div>
            ),
            width: "8%",
          },
          {
            name: "Visit",
            sortable: true,
            sortField: "contract_no_of_visit",

            selector: (row) => (
              <div className="flex flex-col items-end gap-1">
                <span className="text-[14px] font-semibold leading-[normal] text-black">
                  {row.no_of_visit ? row.no_of_visit : 0}
                </span>
              </div>
            ),
            width: "50px",
          },
          {
            name: "Unit",
            sortable: false,
            selector: (row) => (
              <div className="flex flex-col gap-1" data-tag="allowRowEvents">
                <span className="text-[14px] font-semibold leading-[normal] text-black">
                  {row.contract_duration !== "-"
                    ? getColumnNormalHtml(
                        Number(`${row.contract_duration}`).toFixed(2),
                      )
                    : "0.00"}
                </span>
              </div>
            ),
            width: "55px",
          },
          {
            name: "Total",
            sortable: false,
            selector: (row) => (
              <ClientPayPopover
                pay_arr={row?.client_pay_arr}
                shift_rate={
                  Number(row.rate) +
                  Number(row.cover_request_awarded_reward || 0) -
                  Number(row.cover_request_awarded_penalty || 0)
                }
                is_substitute_contract={
                  row?.cover_request_awarded_reward != 0
                    ? 1
                    : row?.cover_request_awarded_penalty != 0
                      ? 1
                      : 0
                }
                cover_request_awarded_penalty={
                  row?.cover_request_awarded_penalty || 0
                }
                cover_request_awarded_reward={
                  row.cover_request_awarded_reward || 0
                }
                content={(content) => (
                  <div
                    className="flex flex-col gap-1"
                    data-tag="allowRowEvents"
                  >
                    {getColumnNormalHtml(content, "cursor-pointer")}
                  </div>
                )}
              />
            ),
            // width: "7.5%",
          },
          {
            name: "Status",
            sortable: true,
            sortField: "timesheet_status",
            // sortFunction: (rowA, rowB) => sortByText(rowA, rowB, "timesheet_status"),
            selector: (row) => (
              <div className="flex flex-col items-end gap-1">
                <WorkedStatusButton
                  timesheet_status={row.timesheet_status}
                  contract_ref_no={row.contract_ref_no}
                  btnClass=" px-2 py-[0.3px] cursor-pointer rounded-md border px-2 text-[14px] font-medium leading-[24px]"
                />
              </div>
            ),
            width: "10%",
            // wrap: true
          },
        ]),
  ];

  /**
   * Renders the expanded row component.
   *
   * @param {Object} data - The data object
   * @return {JSX.Element} The JSX for the expanded row
   */
  const Expandedrow = ({ data }) => (
    <WorkedShifts
      shifts={data.shifts}
      dateFormat="YYYY-MM-DD"
      substitueCon={data?.is_substitute_contract}
    />
  );

  const dataTableRef = useRef();
  /**
   * Handles the table scroll event and triggers fetching of worked candidates when reaching the bottom.
   *
   * @param {Event} e - The event object
   * @return {void}
   */

  //Comman function for debounce
  const handleDebounceScroll = useDebounceScroll(() =>
    dispatch(fetchWorkedCandidates({})),
  );
  useEffect(() => {
    if (dataTableRef.current) {
      const table = dataTableRef.current.querySelector("._DataTable");
      table.addEventListener("scroll", handleDebounceScroll);
      return () => {
        table.removeEventListener("scroll", handleDebounceScroll);
      };
    }
  }, [handleDebounceScroll]);

  const conditionalRowStyles = [
    {
      when: (row) => diffList.includes(row.sign_off_id),
      style: {
        backgroundColor: "#f1f1f1",
      },
    },
  ];

  const firstViewRender = useRef(true);
  useEffect(() => {
    if (firstViewRender.current) {
      firstViewRender.current = false;
      return;
    }
    // Fetching list on changing view
    dispatch(
      updateSorting({
        sortByColumn: "",
        sortByOrder: "",
      }),
    );
    dispatch(setWorkedCandidatesLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(fetchWorkedCandidates(filters));
    dispatch(
      fetchCandidateTypes({
        workedView: listView,
      }),
    );
  }, [listView]);

  const handleSort = ({ sortField: newSortField }) => {
    const { sortByColumn, sortByOrder } = sorting; // get from Redux

    let newSortOrder = "asc";
    if (sortByColumn === newSortField) {
      newSortOrder = sortByOrder === "asc" ? "desc" : "asc";
    }

    dispatch(
      updateSorting({ sortByColumn: newSortField, sortByOrder: newSortOrder }),
    );
    dispatch(deSelectAllCandidate());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setLoading(true));
    dispatch(fetchWorkedCandidates());
  };
  return (
    <div className="WorkedList_Wrapper mb-[58px]">
      <div className="flex h-full flex-col rounded-[10px] bg-white p-4 shadow-[0px_x1px_6px_0px_#E7EFFB]">
        <div className="mb-[20px] flex flex-col flex-wrap gap-3 border-b border-b-[#E8E8E8] pb-[11px] md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap items-center gap-2 md:gap-[21px]">
            <h4 className="main-heading tour-worked-heading font-medium leading-[normal] text-txtDark">
              Candidates Previously Worked
            </h4>
            <Actions diffList={diffList} setDiffList={setDiffList} />
            <SelectedCountText
              selectedCount={selectedCandidate.length}
              totalCount={totalCount}
              isSelectedAll={isSelectedAll}
              clearSelected={() => {
                dispatch(updateToggleSelected());
              }}
              handleSelectAll={(val) => {
                dispatch(toggleSelectedAll(val));
              }}
              updateSelected={(val) => {
                dispatch(updateSelectedCandidate(val));
              }}
              currentDataLength={data.length}
            />
          </div>
          <div className="flex gap-[20px]">
            <SwitchListView
              value={listView}
              handleClick={(value) => {
                dispatch(deSelectAllCandidate());
                dispatch(updateListView(value));
              }}
            />
            <SearchFilter />
            <FilterModal />
          </div>
        </div>
        <div
          className="DataTable_Wrapper hide_extended_arrow min0w-full"
          ref={dataTableRef}
        >
          <DataTable
            columns={columns}
            width="9000px"
            data={data}
            fixedHeader
            onSort={handleSort}
            // persistTableHead={true}
            // persistTableHead={true}
            fixedHeaderScrollHeight="600px"
            progressPending={isLoading}
            progressComponent={<TableLoader rows={5} />}
            selectableRows
            conditionalRowStyles={conditionalRowStyles}
            onSelectedRowsChange={(state) => {
              let selectedIDS = state.selectedRows.map((item) => {
                return item.candidate_id;
              });
              let selectedContract = state.selectedRows.map((item) => {
                return item.contract_id;
              });
              dispatch(updateSelectedCandidate(selectedIDS));
              dispatch(updateSelectedContract(selectedContract));
            }}
            noDataComponent={<TableNoContent />}
            clearSelectedRows={toggleSelected}
            // expandableRows
            // expandOnRowClicked
            // expandableRowsComponent={Expandedrow}
            className="_DataTable Worked_DataTable worked-candidate"
            expandableRows={listView !== "shifts"}
            expandOnRowClicked
            expandableRowsComponent={Expandedrow}
            onRowExpandToggled={(state, row) => {
              if (state) {
                dispatch(
                  fetchWorkedShifts({
                    contractId: row.contract_id,
                    //     candidate_id: row.candidate_id,
                  }),
                );
              }
            }}
          />
        </div>
        {/* pagination loader */}
        {!isLoading && isPaginationLoading ? (
          <DataTablePaginationLoader />
        ) : null}
      </div>
    </div>
  );
};
